import { render } from "./index_v2.vue?vue&type=template&id=73d60cdb&scoped=true"
import script from "./index_v2.vue?vue&type=script&lang=js"
export * from "./index_v2.vue?vue&type=script&lang=js"

import "./index_v2.vue?vue&type=style&index=0&id=73d60cdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d60cdb"]])

export default __exports__